import React, { Component, PropTypes } from 'react'
import ReactTransitionGroup from 'react-addons-transition-group'
import $ from 'jquery'
import Velocity from 'velocity-animate'

class AnimationComponent extends Component {
  componentWillEnter (callback) {
    // $(this.getDOMNode()).hide();
    callback();
  }

  componentDidEnter () {
    // $(this.getDOMNode()).show(duration);
  }

  componentWillLeave (callback) {
    callback();
    // $(this.getDOMNode()).hide(duration, callback);
  }

  componentDidLeave () {
  }

  render () {
    return <img src="./static/img/loading.gif"/>
  }
}

export default class Preload extends Component {

  render () {
    return (
      <div className="loading">
        <ReactTransitionGroup>
          <AnimationComponent key="preloader"/>
        </ReactTransitionGroup>
      </div>
    )
  }
  
  componentDidUpdate(prevProps) {
    const canvas = this.props.canvas
    const oldCanvas = prevProps.canvas
    if (canvas.readyCanvas && !oldCanvas.readyCanvas) {
      Velocity($(".loading")[0], {scale:0}, {duration:800, easing:"easeOutSine"})
    }
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Preload.js
 **/